import { Column } from 'react-table';

export const rulePerformanceRejectColumns: Column<RulePerformanceTableItem>[] = [
    {
        accessor: 'matches',
        id: 'reject',
        Header: 'Matches'
    }
];

export const rulePerformanceAllColumns: Column<RulePerformanceTableItem>[] = [
    {
        accessor: 'matches',
        id: 'all',
        Header: 'Matches'
    }
];
